module.exports = __webpack_public_path__ + "img/card_list.6a0e4f77.svg";